import { Reveal } from "./Reveal";
import { Spine } from "./Spine";

export const Container = ({ className = "", children }) => (
  <div className={`mx-auto w-full max-w-6xl px-4 sm:px-6 ${className}`}>{children}</div>
);

/* Секция прозрачная: фон ей даёт PageAtmosphere. Заголовок слева или по центру. */
export const Section = ({ id, title, lead, center = false, className = "", children }) => (
  <Spine>
    <section id={id} className={`py-24 sm:py-32 ${className}`}>
      <Container>
        <Reveal className={center ? "mx-auto text-center" : ""}>
          <h2 className={`h2 max-w-[760px] ${center ? "mx-auto" : ""}`}>{title}</h2>
          {lead && <p className={`mt-5 max-w-[680px] text-lg text-muted ${center ? "mx-auto" : ""}`}>{lead}</p>}
        </Reveal>
        <div className="mt-12">{children}</div>
      </Container>
    </section>
  </Spine>
);
